import {Component, EventEmitter, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";

@Component({
  selector: 'ui-custom-controls',
  templateUrl: './ui-custom-controls.component.html'
})
export class UiCustomControlsComponent implements OnInit {

  value: boolean = false;
  radio: string = 'Неизвестно';

  group: any;

  constructor() { }

  ngOnInit() {
    this.initForm();
  }

  initForm() {
    this.group = new FormGroup({
      check: new FormControl(true, Validators.requiredTrue),
      radio: new FormControl('Старый')
    });

    this.group.checkForm = new EventEmitter();
  }

  debug() {
    this.group.disable();
  }
}
